export default __webpack_public_path__ + "static/media/HelveticaNowDisplay-Medium.0adbf87c.otf";